// 中国移动地方接口类型选项数据
export function findChinaMobileApiAccountProvinceApiTypeOptions() {
  return [
    { label: '上海', value: 'shanghai' }
  ]
}
